import React from 'react';
import styles from './Status.module.css';


export default function Status({ label }) {
    let classNames = styles.pendingButton;

    switch (label) {
        case 'APPROVED':
            classNames = styles.approveButton;
            break;
        case 'REJECTED':
            classNames = styles.rejectButton;
            break;
        case 'EDIT REQUIRED':
            classNames = styles.editButton;
            break;
        case 'PENDING':
            classNames = styles.pendingButton;
            break;
        case 'PROCESSING':
            classNames = styles.processingButton;
            break;
    }

    return (
        <div className={styles.buttonContainer}>
            <button className={classNames} disabled> {label} </button>
        </div>
    );

};
